






































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import productoModule from "@/store/modules/producto-module";
import { producto } from "@/shared/dtos/producto";
import { RouterNames } from "@/router/routernames";
import { API } from "@/shared/api";

const TAKE = 24;

@Component
export default class BuscadorProductos extends Vue {
  search = "";
  department = "";
  estadoIdx = 0;
  skip = 0;
  productos: producto[] = [];
  cargandoBg = false;
  cargandoMas = false;
  hayMas = true;
  totalResultados = 0;
  private debounceTimer: any = null;
  private observer: IntersectionObserver | null = null;

  async created() {
    if (productoModule.departamentos.length === 0) {
      await productoModule.getDepartamentos();
    }
    await this.buscar(true);
    this.$nextTick(() => this.initObserver());
  }

  beforeDestroy() {
    if (this.observer) this.observer.disconnect();
  }

  get departamentosSelect() {
    return productoModule.departamentos;
  }

  @Watch("estadoIdx")
  onEstadoChange() {
    this.resetYBuscar();
  }

  onSearchInput() {
    clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(() => this.resetYBuscar(), 400);
  }

  onLimpiarSearch() {
    this.search = "";
    this.resetYBuscar();
  }

  resetYBuscar() {
    this.skip = 0;
    this.productos = [];
    this.hayMas = true;
    this.buscar(true);
  }

  limpiarFiltros() {
    this.search = "";
    this.department = "";
    this.estadoIdx = 0;
    this.resetYBuscar();
  }

  async buscar(inicial = false) {
    if (!this.hayMas) return;
    if (inicial) this.cargandoBg = true;
    else this.cargandoMas = true;

    try {
      const res: producto[] = await productoModule.buscarProductosAppend({
        skip: this.skip,
        take: TAKE,
        estado: this.estadoIdx,
        search: this.search || "",
        department: this.department || "",
      });
      const items = res ? res.map((x: any) => new producto(x)) : [];
      if (inicial) {
        this.productos = items;
      } else {
        this.productos = [...this.productos, ...items];
      }
      this.totalResultados = this.skip + items.length;
      this.hayMas = items.length === TAKE;
      this.skip += items.length;
    } finally {
      this.cargandoBg = false;
      this.cargandoMas = false;
    }
  }

  initObserver() {
    const sentinel = this.$refs.sentinel as Element;
    if (!sentinel) return;
    this.observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting && !this.cargandoMas && !this.cargandoBg && this.hayMas) {
        this.buscar(false);
      }
    }, { rootMargin: "200px" });
    this.observer.observe(sentinel);
  }

  getImg(item: producto) {
    if (item.thumb) return item.thumb;
    if (item.hiRes) return item.hiRes;
    if (item.asin) return `https://images-na.ssl-images-amazon.com/images/P/${item.asin}.01._SCLZZZZZZZ_.jpg`;
    return API.webApiBaseRootPath + "Image/ProductImage/" + item.id + "_1.jpg";
  }

  getEstadoName(estado: number) {
    const map: Record<number, string> = {
      0: "Disponible", 1: "Reservado", 2: "Pdte. Pago",
      3: "Merma", 4: "Envío", 5: "V. Tarjeta",
      6: "V. Efectivo", 7: "Reparación", 8: "Devolución",
    };
    return map[estado] !== undefined ? map[estado] : "Estado " + estado;
  }

  getBadgeClass(estado: number) {
    if (estado === 0) return "badge-success";
    if (estado === 3) return "badge-error";
    if (estado === 7) return "badge-warning";
    if ([1, 2, 4].includes(estado)) return "badge-info";
    if ([5, 6].includes(estado)) return "badge-vendido";
    return "badge-grey";
  }

  irAFicha(item: producto) {
    this.$router.push({ name: RouterNames.fichaproducto, params: { id: item.id.toString() } }).catch(() => {});
  }
}
